import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { Scanner } from '../model/scanner';

@Injectable()
export class UserService {
    constructor(private dataService: DataService) { }
    private readonly getScannersEndPoint: string = '/user/getScanners/';
    private readonly getScannersByUserIdEndPoint: string = '/user/getScannersByUserId/';
    private readonly scannerUserUpdateEndPoint: string = '/user/scannerUserUpdate/';
    private readonly scannerDeleteEndPoint: string = '/user/scannerDelete/';
    private readonly getScannerByIdEndPoint: string = '/user/getScannerById/';
    private readonly scannerUpdateEndPoint: string = '/user/scannerUpdate/';

    async getScanners(name?: string): Promise<Scanner[]> {
        const param = { name: name };
        return await this.dataService.get<Scanner[]>
        (this.getScannersEndPoint, param).toPromise();
    }

    async getScannerById(scannerId: number): Promise<Scanner> {
        const param = { scannerId: scannerId };
        return await this.dataService.get<Scanner>
        (this.getScannerByIdEndPoint, param).toPromise();
    }

    async scannerUpdate(scanner: Scanner): Promise<boolean> {
        return await this.dataService.post<boolean>
        (this.scannerUpdateEndPoint, scanner).toPromise();
    }

    async scannerDelete(scanner: Scanner): Promise<boolean> {
        return await this.dataService.post<boolean>
        (this.scannerDeleteEndPoint, scanner).toPromise();
    }

    async getScannersByUserId(userId: number): Promise<Scanner> {
        const param = { userId: userId };
        return await this.dataService.get<Scanner>
          (this.getScannersByUserIdEndPoint, param).toPromise();
    }

    async scannerUserUpdate(userId: number, scannerId: number): Promise<boolean> {
        const param = { UserId: userId,  ScannerId: scannerId};
        return await this.dataService.post<boolean>
        (this.scannerUserUpdateEndPoint, param).toPromise();
    }
}
